import styles from './ResolutionSwitcher.module.scss';

const videoResolutions = [
    {label: "480", key: "fourEighty"},
    {label: "720", key: "sevenTwenty"},
    {label: "1080", key: "tenEighty"},
]

const ResolutionSwitcher = ({player, activeResolution, setActiveResolution}) => {

    return ( 
            <div className={`${styles.resolutionSwitcher} ${(player.hovering || !player.playing) ? styles['resolutionSwitcher-show'] : styles['resolutionSwitcher-hide']}`} initial={{opacity: 0}} animate={{opacity: 1}} exit={{opacity: 0}}>
                {videoResolutions.map((res)=>
                    <div onClick={()=>setActiveResolution(res.key)} className={`${styles.resolutionSwitcher__resolution} ${res.key === activeResolution ? styles['resolutionSwitcher__resolution-active'] : ""}`} key={res.key}>{res.label}</div>
                    )
                }
            </div>
     );
}
 
export default ResolutionSwitcher;